import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LogOplogComponent } from './oplog/oplog.component';

const routes: Routes = [

  { path: 'oplog', component: LogOplogComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LogRoutingModule { }
